








































































































import Vue from 'vue'
import Nav from '@/components/Nav.vue'
import { ApiResponse } from '@/interfaces'
import { mapState } from 'vuex'

interface TemplateData {
  id: number | null
  name: string | null
  type: string | null
  labelType: string | null
  view: string | null
  filename: string | null
  structureType: string | null
}

export default Vue.extend({
  components: { Nav },
  data() {
    return {
      busy: false,
      templateData: {
        id: null,
        name: null,
        type: null,
        labelType: null,
        view: null,
        filename: null,
        structureType: null,
      } as TemplateData,
      autocompleteNone: 'none',
      changeDetected: null as null | boolean,
      uploading: false,
      pendingFile: null as File | null,
      typeOptions: [
        { value: 'vente', label: 'Mandat de vente (vente)', desc: 'Rattachement au lot // Produits par défaut // Ajout auto dans livre de police // Impossible à supprimé si signé' },
        { value: 'depot', label: 'Bon de dépôt (depot)', desc: 'Rattachement au lot' },
        { value: 'proces_verbal', label: 'Procès verbal (proces_verbal)', desc: 'Contrôles sur données obligatoires (judiciaire/volontaire) // Contrôles des lots judiciaire ou volontaire // Numérotation // Droit pour suppression' },
        { value: 'inventory', label: 'Inventaire (inventory)', desc: 'Droit pour suppression' },
        { value: 'restitution', label: 'Bon de restitution (restitution)', desc: 'Sortie de stock // changement de status' },
        { value: 'bon_livraison', label: 'Bon de livraison (bon_livraison)', desc: 'Sortie de stock // changement de status // Numérotation' },
        { value: 'bon-enlevement', label: "Mail bon d'enlèvement (bon-enlevement)", desc: "Filtre lots adjugés" },
        { value: 'mail', label: 'Mail (mail)', desc: 'Aucune règle particulière' },
      ],
      viewOptions: [
        { value: 'inventory', label: 'Inventaire (inventory)' },
        { value: 'requisition', label: 'Réquisition (requisition)' },
        { value: 'sale', label: 'Vente (sale)' },
        { value: 'contact', label: 'Contact (contact)' },
        { value: 'mail-document', label: 'Email document (mail-document)' },
        { value: 'mail-invoice', label: 'Email facture (mail-invoice)' },
        { value: 'requisition-item', label: 'Lot de réquisition (requisition-item)' },
        { value: 'mail-seller', label: 'Email vendeur (mail-seller)' },
        { value: 'mail-buyer', label: 'Email acheteur (mail-buyer)' },
        { value: 'invoice', label: 'Facture (invoice)' },
      ],
    }
  },
  computed: {
    ...mapState(['user', 'connectedAs']),
    templateId(): number | null {
      const rawId = this.$route.params.id
      if (!rawId) return null
      const parsed = Number(rawId)
      return Number.isNaN(parsed) ? null : parsed
    },
    fileBasename(): string {
      if (!this.templateData.filename) return ''
      return this.templateData.filename.split('/').pop() || this.templateData.filename
    },
  },
  watch: {
    templateId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchTemplate(newVal)
        }
      },
    },
    templateData: {
      deep: true,
      immediate: true,
      handler() {
        if (this.changeDetected === false) {
          this.changeDetected = true
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.changeDetected = false
    })
  },
  methods: {
    setAttribute() {
      this.autocompleteNone = 'none'
    },
    goBack() {
      this.$router.back()
    },
    fetchTemplate(id: number) {
      this.busy = true
      this.$api
        .get(`/template/${id}`)
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          this.setTemplateData(apiResponse.data)
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Impossible de charger le template.',
          })
        })
        .finally(() => {
          this.busy = false
          this.$nextTick(() => {
            this.changeDetected = false
          })
        })
    },
    setTemplateData(data: TemplateData) {
      this.templateData = { ...data }
      this.pendingFile = null
      const input = this.$refs.fileInput as HTMLInputElement | undefined
      if (input) input.value = ''
    },
    triggerFileInput() {
      (this.$refs.fileInput as HTMLInputElement).click()
    },
    onFileChange(event: Event) {
      const input = event.target as HTMLInputElement
      this.pendingFile = input.files?.[0] ?? null
    },
    downloadFile() {
      this.$api
        .get(`/template/${this.templateId}/download`)
        .then((response: any) => {
          const filename = response.data?.data?.filename
          if (!filename) throw new Error('filename missing')
          window.open(`${process.env.VUE_APP_API_URL}/document/${filename}/download_once`, '_blank')
        })
        .catch(() => {
          this.$notify({ type: 'error', title: 'Erreur', message: 'Impossible de télécharger le fichier.' })
        })
    },
    uploadFile() {
      if (!this.pendingFile || !this.templateId) return
      this.uploading = true
      const formData = new FormData()
      formData.append('file', this.pendingFile)
      this.$api
        .post(`/template/${this.templateId}/upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response: any) => {
          const apiResponse = response.data
          this.setTemplateData(apiResponse.data)
          this.$notify({ type: 'success', title: 'Succès', message: 'Fichier uploadé avec succès !' })
        })
        .catch((error: any) => {
          const msg = error.response?.data?.message ?? 'Erreur lors de l\'upload.'
          this.$notify({ type: 'error', title: 'Erreur', message: msg })
        })
        .finally(() => {
          this.uploading = false
        })
    },
    submit() {
      this.busy = true
      const loading = this.$loading({
        target: '.form-panel',
        text: 'Enregistrement...',
      })

      const payload = {
        ...this.templateData,
        structureType: this.templateData.structureType || null,
      }
      this.$api
        .put(`/template/${this.templateId}`, payload)
        .then((response) => {
          const apiResponse = response.data
          this.setTemplateData(apiResponse.data)
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: 'Template modifié avec succès !',
          })
        })
        .catch((error) => {
          if (error.response) {
            const apiResponse = error.response.data as ApiResponse
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          }
        })
        .finally(() => {
          this.busy = false
          this.changeDetected = false
          loading.close()
        })
    },
    duplicate() {
      if (!this.templateId) return
      this.busy = true
      this.$api
        .post(`/template/${this.templateId}/duplicate`)
        .then((response: any) => {
          const newId = response.data?.data?.id
          this.$notify({ type: 'success', title: 'Succès', message: 'Template dupliqué avec succès !' })
          this.$router.push({ name: 'template', params: { id: String(newId) } })
        })
        .catch((error: any) => {
          const msg = error.response?.data?.message ?? 'Erreur lors de la duplication.'
          this.$notify({ type: 'error', title: 'Erreur', message: msg })
        })
        .finally(() => {
          this.busy = false
        })
    },
    confirmDelete() {
      this.$confirm(
        `Supprimer le template "${this.templateData.name || ''}" ? Cette action est irréversible.`,
        'Confirmer la suppression',
        {
          confirmButtonText: 'Supprimer',
          cancelButtonText: 'Annuler',
          type: 'warning',
        }
      ).then(() => {
        this.busy = true
        this.$api
          .delete(`/template/${this.templateId}`)
          .then(() => {
            this.$notify({ type: 'success', title: 'Succès', message: 'Template supprimé avec succès !' })
            this.$router.back()
          })
          .catch((error: any) => {
            const msg = error.response?.data?.message ?? 'Erreur lors de la suppression.'
            this.$notify({ type: 'error', title: 'Erreur', message: msg })
            this.busy = false
          })
      }).catch(() => {
        // annulation
      })
    },
  },
})
